var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",style:(_vm.style)},[_c('div',{staticClass:"box-name"},[_vm._v("#"+_vm._s(_vm.index))]),_c('div',{staticClass:"size-info"},[_vm._v(_vm._s(_vm.w)+"x"+_vm._s(_vm.h))])])}
var staticRenderFns = []

export { render, staticRenderFns }